import { render, staticRenderFns } from "./DatasetRightSideBar.vue?vue&type=template&id=a74a880c&scoped=true&"
import script from "./DatasetRightSideBar.vue?vue&type=script&lang=js&"
export * from "./DatasetRightSideBar.vue?vue&type=script&lang=js&"
import style0 from "./DatasetRightSideBar.vue?vue&type=style&index=0&id=a74a880c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a74a880c",
  null
  
)

export default component.exports